import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/components/auth/AuthProvider';
import { GoogleSignInButton } from '@/components/auth/GoogleSignInButton';
import { BrandLockup } from '@/components/BrandLockup';
import { useEffect } from 'react';

export default function LoginPage() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) navigate('/dashboard', { replace: true });
  }, [isAuthenticated, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-md p-8 space-y-8 bg-card rounded-2xl border shadow-(--shadow-md)">
        <div className="text-center space-y-3">
          <h1 className="sr-only">ValueGraph</h1>
          <div className="flex justify-center">
            <BrandLockup variant="stacked" />
          </div>
          <p className="text-sm text-muted-foreground">
            Trace every feature back to a real need.
          </p>
        </div>

        <div className="space-y-4">
          <GoogleSignInButton onSuccess={() => navigate('/dashboard')} />

          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t" />
            </div>
            <div className="relative flex justify-center text-xs uppercase tracking-wide">
              <span className="bg-card px-2 text-muted-foreground">
                Only Google sign-in is supported
              </span>
            </div>
          </div>
        </div>

        <p className="text-center text-xs text-muted-foreground">
          By signing in, you agree to our Terms of Service and{' '}
          <Link to="/privacy" className="hover:text-foreground">
            Privacy Policy
          </Link>
        </p>

        <p className="text-center text-xs text-muted-foreground">
          <a href="/" className="hover:text-foreground">
            What is ValueGraph?
          </a>
        </p>
      </div>
    </div>
  );
}
